import { $t } from '@teachino/shared-i18n';
import type { Display } from '@teachino/shared-util';
import { ref, shallowRef } from 'vue';
import TToast from './TToast.vue';

const TOAST_DISPLAY_TIME_MS = 5000;
const displayRef = shallowRef<Display | null>(null);
const isOpen = ref(false);
let timeout: ReturnType<typeof setTimeout> | null = null;

export function useToast() {
  function open(display: Display): void {
    displayRef.value = display;
    isOpen.value = true;
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(dismiss, TOAST_DISPLAY_TIME_MS);
  }

  function dismiss() {
    isOpen.value = false;
    displayRef.value = null;
  }

  return {
    success: (message: string, header?: string) => {
      open({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        component: TToast,
        variant: 'success',
        description: message,
        header,
      });
    },
    error: (message?: string) => {
      open({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        component: TToast,
        variant: 'error',
        description: message ?? $t('generic_error'),
      });
    },
    info: (message: string) => {
      open({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        component: TToast,
        variant: 'info',
        description: message,
      });
    },
    isOpen,
    displayRef,
    open,
    dismiss,
  };
}
